import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getRoute } from "../utils/routes";
import {
  RiAddCircleLine,
  RiFileList2Line,
  RiLogoutCircleRLine,
  RiHome3Line,
  RiShoppingCartLine,
  RiCalendar2Fill,
} from "react-icons/ri";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirmLogout = window.confirm(
      "¿Estás seguro de que quieres cerrar sesión?"
    );
    if (confirmLogout) {
      logout();
      navigate("/login");
    }
  };

  // ✅ Configuración de menús con roles permitidos
  const menuItems = [
    {
      label: "Dashboard",
      icon: <RiHome3Line className="text-white" />,
      path: "",
      roles: ["admin"],
    },
    {
      label: "Home",
      icon: <RiHome3Line className="text-white" />,
      path: "UserHome",
      roles: ["admin", "user", "oper", "tec"],
    },
    {
      label: "Productos",
      icon: <RiShoppingCartLine className="text-white" />,
      path: "productos",
      roles: ["admin", "user"],
    },
    {
      label: "Instalaciones",
      icon: <RiFileList2Line className="text-white" />,
      path: "instalacion",
      roles: ["admin", "user", "tec"],
    },
    {
      label: "Presupuestos",
      icon: <RiFileList2Line className="text-white" />,
      path: "presupuesto",
      roles: ["admin", "user"],
    },
    {
      label: "Añadir Averías",
      icon: <RiAddCircleLine className="text-white" />,
      path: "addTicket",
      roles: ["admin", "user", "oper"],
    },
    {
      label: "Averías",
      icon: <RiFileList2Line className="text-white" />,
      path: "ticket",
      roles: ["admin", "user", "oper", "tec"],
    },
    {
      label: "Partes",
      icon: <RiFileList2Line className="text-white" />,
      path: "parte",
      roles: ["admin", "user", "tec"],
    },
    {
      label: "Calendario",
      icon: <RiCalendar2Fill className="text-white" />,
      path: "calendario",
      roles: ["admin", "user", "oper", "tec"],
    },
  ];

  return (
    <div
      className={`fixed top-0 left-0 h-screen w-64 bg-secondary-150 p-6 z-50 transform transition-transform duration-300 overflow-y-auto xl:translate-x-0 xl:block ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="flex flex-col h-full">
        {/* Parte superior */}
        <div className="flex-grow">
          <h1 className="text-center text-2xl font-bold text-white mb-8">
            Itesa Seguridad
          </h1>
          <nav className="space-y-2">
            {menuItems
              .filter((item) => item.roles.includes(user?.role))
              .map((item, index) => (
                <Link
                  key={index}
                  to={getRoute(user, item.path)}
                  className="flex items-center gap-4 py-2 px-4 rounded-lg hover:bg-secondary-900 transition-colors"
                >
                  {item.icon}
                  {item.label}
                </Link>
              ))}
          </nav>
        </div>

        {/* Botón de logout */}
        <div>
          <button
            type="button"
            onClick={handleLogout}
            className="flex items-center gap-4 py-2 px-4 rounded-lg bg-secondary-900 transition-colors text-white w-full"
          >
            <RiLogoutCircleRLine />
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
